module.exports = __webpack_public_path__ + "img/0Q3A3494_L_WoodMatted.f1818716.jpg";